<template>
    <!-- 列表部分 -->
    <div class="listContent">
        <div  class="search-content conditionSearchBox mt-20">
            <div class="conditionItem">
                <el-input size="medium" clearable  prefix-icon="el-icon-search" placeholder="班级名称" v-model="params.classname" ></el-input>
            </div>
            <div class="conditionItem">
                <el-input size="medium" clearable  prefix-icon="el-icon-search" placeholder="校区名称" v-model="params.campusname" ></el-input>
            </div>
            <div class="conditionItem">
                <el-input size="medium" clearable  prefix-icon="el-icon-search" placeholder="课程名称" v-model="params.classcoursename" ></el-input>
            </div>
            <div class="conditionItem">
                <el-input size="medium" clearable  prefix-icon="el-icon-search" placeholder="课时名称" v-model="params.periodname" ></el-input>
            </div>
            <div class="conditionItem">
                <el-button type="hollowOut" @click="triggerSearch">
                    <i class="el-icon-search mr-5"></i>搜索</el-button>
                <el-button @click="resetSearchCondition">
                    <i class="el-icon-refresh mr-5"></i>重置</el-button>
            </div>
        </div>
        <div class="listBox mt-20">
             <!-- 表格 -->
            <div v-loading="loadingStatus" class="table-content mt-15">
                <el-table class="table-fixed-col" ref="multipleTable" border :data="tableData" style="width: 100%">
                    <el-table-column key="index" type="index" :width="getTableHeaderWidthByOrderCol()"  align="center" label="序号"
                        fixed="left">
                        <template slot-scope="scope">
                            <TableSort :index="scope.$index" :page="params.page" :pagesize="params.pagesize" />
                        </template>
                    </el-table-column>
                    <el-table-column min-width="140" show-overflow-tooltip key="classname" align="center" prop="classname" label="班级名称">
                    </el-table-column>
                    <el-table-column min-width="140" show-overflow-tooltip key="classcoursename" align="center" prop="classcoursename" label="课程名称">
                    </el-table-column>
                    <el-table-column min-width="140" show-overflow-tooltip key="periodname" align="center" prop="periodname" label="课时名称">
                        <template slot-scope="scope">
                            <span @click="goDetail(scope.row)" class="classcoursename">{{scope.row.periodname}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="140"  key="perioddate" align="center" prop="perioddate" label="课程时间">
                    </el-table-column>
                    <el-table-column min-width="140" key="starttime" align="center" prop="starttime" label="课时日期">
                    </el-table-column>
                    <el-table-column min-width="120" key="endtime" show-overflow-tooltip align="center" prop="endtime" label="课时时间">
                    </el-table-column>
                    <el-table-column width="100" key="periodmodename" align="center" prop="periodmodename" label="授课模式">
                    </el-table-column>
                    <el-table-column min-width="120" show-overflow-tooltip key="teachername" align="center" prop="teachername" label="授课老师">
                    </el-table-column>
                    <el-table-column width="100" key="statusname" align="center" prop="statusname" label="授课状态">
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>
<script>
import {getScheduleByTable} from '@/api/measApi/teachManagement.js'
import {getTableDefaultPageSize} from '@/assets/measAssets/js/tools.js'
import TableSort from '@/components/measComponents/tableSort/tableSort.vue'
export default {
    data(){
        return {
            loadingStatus: false,
            params: {
                campuscode: '',
                campusname: '',
                classcode: '',
                classcoursecode: '',
                classcoursename: '',
                classname: '',
                enddate: '',
                periodcode: '',
                periodname: '',
                startdate: ''
            },
            tableData: []
        }
    },
    components: {
        TableSort,
    },
    created(){
        this.getTableList()
    },
    methods: {
        getTableList(){
            getScheduleByTable(this.params).then(res => {
                this.tableData = res.data
                console.log(res,'课表')
            })
        },
        triggerSearch(){
            this.getTableList()
        },
        resetSearchCondition(){
            this.params.classname = ''
            this.params.campusname = ''
            this.params.classcoursename = ''
            this.params.periodname = ''
            this.getTableList()
        },
        goDetail(row){
            this.$router.push({ name: 'CoursePeriodDetail', query: { code: row.classcoursecode, classCode: row.classcode, coursePeriodCode: row.code } })
        }
    }
}
</script>
<style lang="scss">
.classcoursename{
    color: #0B75FA;
    cursor: pointer;
}
</style>